module.exports = __webpack_public_path__ + "static/media/logo.4ff16f83.svg";